var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusiconblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2147",
    "data-name": "Group 2147",
    transform: "translate(-406 -588.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_152_3",
    "data-name": "Component 152 \\u2013 3",
    transform: "translate(406 588.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-plus-869752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8884",
    "data-name": "Path 8884",
    d: "M86.52,9.519a7,7,0,1,0,7,7,7,7,0,0,0-7-7Zm3.464,7.406H86.824v3.159a.391.391,0,1,1-.783,0V16.925H82.9a.391.391,0,1,1,0-.783h3.159V12.983a.391.391,0,1,1,.783,0v3.159H90a.39.39,0,0,1,.391.391.412.412,0,0,1-.406.391Z",
    transform: "translate(-79.52 -9.519)",
    fill: "#4eb6ee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-pop-up-2186785",
    transform: "translate(2.742 3.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8886",
    "data-name": "Path 8886",
    d: "M311.14,50.213H308.3V47.375a.71.71,0,0,0-1.419,0v2.838h-2.838a.71.71,0,0,0,0,1.419h2.838v2.838a.71.71,0,0,0,1.419,0V51.632h2.838a.71.71,0,0,0,0-1.419Z",
    transform: "translate(-303.335 -46.665)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusiconblue);
export default __webpack_public_path__ + "static/media/plusiconblue.4058dd9ab6c7fb332b6b6c701f132ce6.svg";
export { ForwardRef as ReactComponent };